<style>
  .Men {
    background-color: #7bd5dd !important;
  }

  .Women {
    background-color: #e86c37 !important;
  }
</style>

<div class="card card-statistics mb-30">
  <div class="card-body">
    <h5 class="card-title">Customer Information «{{Edit_Customer_Record.code}}» - {{Edit_Customer_Record.name}}</h5>
    <form [formGroup]="EdCustomer">

      <div class="row">

        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">Province </label>
          <select disabled class="custom-select" formControlName="ProvinceId" (change)="ProvinceChange()">
            <option value="0">Select</option>
            <option *ngFor="let item of DataList_Province" [value]="item.code">{{item.title}}</option>
          </select>
        </div>
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">County</label>
          <select disabled class="custom-select" formControlName="CityId">
            <option value="0">Select</option>
            <option *ngFor="let item of DataList_City" [value]="item.id">{{item.title}}</option>
          </select>
        </div>

      </div>

    </form>



    <br />
    <hr />
    <br />

    <h5> Address </h5>

    <div class="table-responsive">
      <table class="mb-0 table table-bordered table-3 text-center table-striped">
        <thead style="background-color: #489b39; color: white;">
          <tr>
            <th>#</th>
            <th>Address Title</th>
            <th>Address</th>
            <th>Certificate Address</th>
            <th>Postal Code</th>
            <th>Area Code</th>
            <th>Phone</th>
            <th>Fax</th>
            <th>Email</th>
            <th>Description</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of DataList_Address">
            <td>{{DataList_Address.indexOf(item)+1}}</td>
            <td>{{item.title}}</td>
            <td>{{item.address}}</td>
            <td>{{item.certificateAddress}}</td>
            <td>{{item.codepost}}</td>
            <td>{{item.pishShomareh}}</td>
            <td>
              <table class="mb-0 table table-bordered table-3 text-center table-striped">
                <tr style="background-color: #accba7;" *ngFor="let itemDetail of item.tel">
                  <td>
                    {{item.tel.indexOf(itemDetail)+1}}
                  </td>
                  <td>
                    {{itemDetail.title}}
                  </td>
                </tr>
              </table>
            </td>
            <td>{{item.fax}}</td>
            <td>
              <table class="mb-0 table table-bordered table-3 text-center table-striped">
                <tr style="background-color: #accba7;" *ngFor="let itemDetail of item.email">
                  <td>
                    {{item.email.indexOf(itemDetail)+1}}
                  </td>
                  <td>
                    {{itemDetail.title}}
                  </td>
                </tr>
              </table>
            </td>
            <td>{{item.dsc}}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <br />
    <hr />
    <br />

    <h5> Calibration Representative </h5>

    <div class="table-responsive">
      <table class="mb-0 table table-bordered table-3 text-center table-striped">
        <thead style="background-color: #489b39; color: white;">
          <tr>
            <th>#</th>
            <th>Name</th>
            <th>Last Name</th>
            <th>Gender</th>
            <th>Position</th>
            <th>Email</th>
            <th>Internal</th>
            <th>Phone</th>
            <th>Mobile Number</th>
            <th>Alternate Mobile</th>
            <th>Messaging Mobile</th>
            <th>Description</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of DataList_KarshnasMasol" [ngClass]="{'Men': item.sex===1,'Women': item.sex===0}">
            <td>{{DataList_KarshnasMasol.indexOf(item)+1}}</td>
            <td>{{item.fname}}</td>
            <td>{{item.lname}}</td>
            <td>
              <p *ngIf="item.sex==0">Female</p>
              <p *ngIf="item.sex==1">Male</p>
            </td>
            <td>{{item.semat}}</td>

            <td>
              <table class="mb-0 table table-bordered table-3 text-center table-striped">
                <tr style="background-color: #accba7;" *ngFor="let itemDetail of item.Email">
                  <td>
                    {{item.Email.indexOf(itemDetail)+1}}
                  </td>
                  <td>
                    {{itemDetail.title}}
                  </td>
                </tr>
              </table>
            </td>

            <td>
              <table class="mb-0 table table-bordered table-3 text-center table-striped">
                <tr style="background-color: #accba7;" *ngFor="let itemDetail of item.Dakhli">
                  <td>
                    {{item.Dakhli.indexOf(itemDetail)+1}}
                  </td>
                  <td>
                    {{itemDetail.title}}
                  </td>
                </tr>
              </table>
            </td>

            <td>
              <table class="mb-0 table table-bordered table-3 text-center table-striped">
                <tr style="background-color: #accba7;" *ngFor="let itemDetail of item.Tel">
                  <td>
                    {{item.Tel.indexOf(itemDetail)+1}}
                  </td>
                  <td>
                    {{itemDetail.title}}
                  </td>
                </tr>
              </table>
            </td>
            <td>{{item.mobile}}</td>
            <td>{{item.jaygozinMiblie}}</td>
            <td>{{item.majaziMobile}}</td>
            <td>{{item.dsc}} </td>

          </tr>
        </tbody>
      </table>
    </div>

    <br />





  </div>
</div>
